/* ============================================================
   La Nani — „Adaugă în coș" cu fereastră, în locul sertarului

   Un singur fișier pentru tot ce ține de adăugarea în coș, oriunde s-ar
   întâmpla: butonul mare de pe pagina produsului, cardurile din colecție și
   selectorul de produse din fereastră.

   FEREASTRA ARE DOUĂ ECRANE
   1. confirmare — ce ai adăugat, cât mai ai până la transport gratuit, și
      două drumuri: „mai adaugă un model" sau „finalizează comanda";
   2. alegere — selector pe tot ecranul, două produse pe rând. Fără link spre
      pagina produsului: singurul lucru apăsabil e „Adaugă în coș". Jos stă
      mereu butonul de finalizare, cu ce ai în coș.

   De ce selector și nu un link spre /collections/all: o pagină nouă înseamnă
   o încărcare completă, iar la fiecare încărcare se pierd oameni. Excepție:
   dacă omul e DEJA pe o pagină de colecție, nu are rost nici selectorul —
   închidem fereastra și derulăm la grila care e deja sub ochii lui.

   DE UNDE A VENIT ADĂUGAREA
   Fiecare linie din coș primește proprietatea `_sursa`, iar comanda primește
   atributul „Adaugat din" cu lista surselor. Așa se vede în Shopify, pe
   comandă, dacă produsul a fost luat de pe pagina lui, din colecție sau din
   selectorul ăsta. Numele începe cu `_` ca să nu se arate clientului.

   CUM SE LEAGĂ DE RESTUL
   - `[data-ln-checkout]` (pagina produsului) și `[data-ln-add]` (cardurile
     din colecție) sunt prinse aici, pe faza de CAPTURĂ.
   - assets/la-nani-easysell.js și assets/la-nani-adauga.js se dau singure la
     o parte cât timp fereastra există în pagină. Nu ne bazăm pe ordinea
     scripturilor: ambii ascultători stau pe captură, iar `stopPropagation`
     nu oprește un alt ascultător pus pe același nod.
   - Butoanele de finalizare au `name="checkout"`, deci le prinde
     ascultătorul de coș din la-nani-easysell.js.
   ============================================================ */
(function () {
  'use strict';

  /* Trebuie să fie același cu PRAG din assets/la-nani-formular.js și cu
     textele „Transport gratuit peste ... lei" din theme editor. */
  var PRAG = 350;

  /* Ce știm despre coș fără să întrebăm serverul.

     Fără cache, fiecare apăsare pornea un lanț de cereri — adaugă, citește
     coșul, scrie sursa, cere secțiunile — și fereastra stătea goală o
     secundă-două. Acum arătăm imediat ce putem calcula singuri și corectăm
     după, când răspunde serverul. */
  var cosStiut = null;
  var surseScrise = null;

  var gazda, poza, nume, pret, prag, pragText, bara, rezumat, unul, lista, bifa;
  var prag2, pragText2, bara2, rezumat2;
  var ecranConfirm, ecranAlege;

  /* Prețurile — cele pe care omul chiar le plătește — se scriu exact:
     „149,99 lei". Nu rotunjim niciodată o sumă de plată. */
  function lei(bani) {
    return (bani / 100).toFixed(2).replace('.', ',') + ' lei';
  }

  /* Prețurile vechi, pe variantă, scrise în pagină de snippet. /cart.js nu
     le întoarce — el știe doar cât plătește omul acum. */
  var vechi = null;
  function pretVechi(idVarianta) {
    if (vechi === null) {
      var el = document.querySelector('[data-ln-cos-preturi]');
      try { vechi = el ? (JSON.parse(el.textContent) || {}) : {}; }
      catch (e) { vechi = {}; }
    }
    return vechi[String(idVarianta)] || 0;
  }

  /* Același format ca pe pagina produsului: zecimalele mici, ridicate, ca pe
     eticheta de magazin — „239⁹⁹ lei". Pe un rând, cifrele mari fac prețul să
     pară mai mare decât e.

     Când există preț vechi, se arată întâi el, tăiat, apoi cel de plată. */
  function bucataPret(bani, clasa) {
    var intreg = Math.floor(bani / 100);
    var zec = ('0' + (bani % 100)).slice(-2);
    return '<span class="' + clasa + '">' +
           '<span class="ln-pret__int">' + intreg + '</span>' +
           '<sup class="ln-pret__zec">' + zec + '</sup> ' +
           '<span class="ln-pret__mon">lei</span></span>';
  }

  function pretHTML(deplata, inainte) {
    var out = '';
    if (inainte && inainte > deplata) out += bucataPret(inainte, 'ln-pret__vechi');
    out += bucataPret(deplata, 'ln-pret__nou');
    return '<span class="ln-pret">' + out + '</span>';
  }

  /* Cât mai lipsește până la transport gratuit se scrie rotund: „110 lei",
     nu „110,01 lei". Nu e un preț, e o distanță — iar bănuții din coadă doar
     îngreunează cititul. Zecimalele rămân doar sub un leu, unde numărul
     întreg ar fi zero și mesajul n-ar mai avea sens. */
  function leiRotund(bani) {
    if (bani < 100) return (bani / 100).toFixed(2).replace('.', ',') + ' lei';
    return Math.round(bani / 100) + ' lei';
  }
  function q(s) { return gazda ? gazda.querySelector(s) : null; }

  function leaga() {
    if (gazda) return true;
    gazda = document.querySelector('[data-ln-cos]');
    if (!gazda) return false;

    ecranConfirm = q('[data-ln-cos-confirm]');
    ecranAlege = q('[data-ln-cos-alege]');
    poza = q('[data-ln-cos-poza]');
    nume = q('[data-ln-cos-nume]');
    pret = q('[data-ln-cos-pret]');
    prag = q('[data-ln-cos-prag]');
    pragText = q('[data-ln-cos-prag-text]');
    bara = q('[data-ln-cos-bara]');
    rezumat = q('[data-ln-cos-rezumat]');
    unul = q('[data-ln-cos-unul]');
    lista = q('[data-ln-cos-lista]');
    bifa = q('.ln-cos__bifa');
    prag2 = q('[data-ln-cos-prag2]');
    pragText2 = q('[data-ln-cos-prag-text2]');
    bara2 = q('[data-ln-cos-bara2]');
    rezumat2 = q('[data-ln-cos-rezumat2]');

    gazda.addEventListener('click', function (ev) {
      if (ev.target.closest('[data-ln-cos-inchide]')) { inchide(); return; }
      if (ev.target.closest('[data-ln-cos-inapoi]')) { arataEcran('confirm'); return; }
      if (ev.target.closest('[data-ln-cos-mai]')) { maiAdauga(); return; }
      var sterge = ev.target.closest('[data-ln-cos-sterge]');
      if (sterge) { ev.preventDefault(); stergeLinie(sterge); return; }
      var add = ev.target.closest('[data-ln-cos-add]');
      if (add) { ev.preventDefault(); adaugaDinSelector(add); }
    });
    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && !gazda.hidden) inchide();
    });
    return true;
  }

  /* ---------- deschidere, închidere, comutarea ecranelor ---------- */
  function deschide() {
    if (!leaga()) return;
    gazda.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    /* o pauză, nu un cadru: într-o filă care nu e în față browserul nu
       rulează cadre, iar fereastra ar rămâne invizibilă */
    setTimeout(function () { gazda.classList.add('ln-cos--intra'); }, 20);
  }

  /* Blocarea derulării o eliberăm ÎNTOTDEAUNA aici. A fost o versiune care o
     lăsa pusă când plecam spre formularul EasySell, presupunând că o preia
     el. Nu o preia: el își pune propria blocare și, la „×", și-o eliberează
     doar pe a lui. A mea rămânea pe <html> și pagina îngheța. */
  function inchide() {
    if (!gazda) return;
    gazda.classList.remove('ln-cos--intra');
    document.documentElement.style.overflow = '';
    setTimeout(function () {
      gazda.hidden = true;
      arataEcran('confirm');
    }, 340);
  }

  function arataEcran(care) {
    if (!ecranConfirm || !ecranAlege) return;
    var alege = care === 'alege';
    ecranConfirm.hidden = alege;
    ecranAlege.hidden = !alege;
    gazda.classList.toggle('ln-cos--alegere', alege);
    if (alege) {
      var grila = gazda.querySelector('.ln-cos__grila');
      if (grila) grila.scrollTop = 0;
    }
  }

  /* ---------- „Mai adaugă un model" ---------- */
  function peColectie() {
    return /^\/collections\//.test(window.location.pathname) &&
           !!document.querySelector('.ln-grid');
  }

  function maiAdauga() {
    /* Pe colecție grila e deja sub fereastră: închidem și atât.

       Aici se derula până sus la grilă. Era greșit: omul tocmai adăugase un
       produs din locul în care se afla, iar butonul îl arunca înapoi la
       începutul listei, printre modele pe care le trecuse deja. Nu mutăm
       pagina — rămâne exact unde era. */
    if (peColectie()) {
      inchide();
      return;
    }
    arataEcran('alege');
  }

  /* ---------- ce scrie în fereastră ---------- */
  function arataProdus(item) {
    if (!item) return;
    if (poza) {
      if (item.image) poza.src = item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2');
      else poza.removeAttribute('src');
    }
    if (nume) nume.textContent = item.product_title || item.title || '';
    if (pret) {
      var unitar = item.final_price !== undefined ? item.final_price : item.price;
      var v = pretVechi(item.variant_id || item.id);
      pret.innerHTML = (item.quantity > 1 ? '<span class="ln-cos__buc">' + item.quantity + ' × </span>' : '') +
                       pretHTML(unitar, v);
    }
  }

  function unPrag(cutie, text, umplut, total) {
    if (!cutie) return;
    var lipsa = PRAG * 100 - total;
    var atins = lipsa <= 0;
    cutie.hidden = false;
    cutie.classList.toggle('ln-cos__prag--atins', atins);
    if (text) {
      text.innerHTML = atins
        ? '<b>Livrarea este gratuită.</b>'
        : 'Mai adaugi <b>' + leiRotund(lipsa) + '</b> și ai <b>transport gratuit</b>.';
    }
    if (umplut) {
      var p = Math.max(0, Math.min(100, (total / (PRAG * 100)) * 100));
      umplut.style.width = p.toFixed(1) + '%';
    }
  }

  function arataCosul(cos, estimare) {
    if (!cos) return;
    var total = cos.total_price || 0;
    var buc = cos.item_count || 0;
    var text = buc ? buc + (buc === 1 ? ' produs' : ' produse') + ' · ' + lei(total) : '';

    /* Cu coșul gol nu are ce progres să arate: bara ar spune „mai adaugi
       350 lei", ceea ce e adevărat dar inutil când nu ai nimic. */
    if (!buc) {
      if (prag) prag.hidden = true;
      if (prag2) prag2.hidden = true;
    } else {
      unPrag(prag, pragText, bara, total);
      unPrag(prag2, pragText2, bara2, total);
    }
    if (rezumat) rezumat.textContent = text;
    if (rezumat2) rezumat2.textContent = text;

    /* La estimare nu cerem nimic de la server — abia la confirmare. */
    if (!estimare) improspateazaTema();
    if (gazda) gazda.classList.remove('ln-cos--asteapta');
  }

  /* Bulina de pe coșul din header.

     NU mai atingem sertarul lateral al temei. O versiune anterioară îi
     rescria conținutul, iar widgetul de recenzii Judge.me — care se
     reinițializează la orice schimbare mare de DOM — ajungea uneori să se
     așeze înăuntru: omul deschidea coșul și vedea recenzii în loc de
     produse. Acum sertarul nu se mai deschide deloc (iconița deschide
     fereastra noastră), deci nici nu are ce să rămână învechit. */
  function improspateazaTema() {
    fetch('/?sections=cart-icon-bubble', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (d) pune_bucata(d['cart-icon-bubble'], '#cart-icon-bubble', '#shopify-section-cart-icon-bubble');
      })
      .catch(function () {});
  }

  function pune_bucata(html, undeSelector, deUndeSelector) {
    if (!html) return;
    var tinta = document.querySelector(undeSelector);
    if (!tinta) return;
    var cutie = document.createElement('div');
    cutie.innerHTML = html;
    var sursa = cutie.querySelector(deUndeSelector) || cutie;
    tinta.innerHTML = sursa.innerHTML;
  }

  /* ---------- fereastra ca vedere a coșului ----------
     Deschisă din iconița de sus: în loc de „ce tocmai ai adăugat", arată tot
     ce e în coș. Așa sertarul temei devine inutil. */
  function arataLista(cos, cheieSus) {
    if (!lista || !unul) return;

    /* Cu `cheieSus` suntem pe ecranul de confirmare: linia tocmai adăugată
       rămâne sus, în `unul`, iar dedesubt vine restul coșului. Fără ea,
       fereastra e deschisă din iconiță și arată tot coșul ca listă. */
    var doarRestul = !!cheieSus;
    unul.hidden = !doarRestul;
    lista.hidden = false;
    if (bifa) bifa.textContent = doarRestul ? 'Adăugat în coș' : 'Coșul tău';

    var itemi = (cos && cos.items) ? cos.items.slice() : [];
    if (doarRestul) {
      itemi = itemi.filter(function (i) { return i.key !== cheieSus; });
    }

    /* Pe confirmare coșul nu are cum să fie gol — tocmai s-a adăugat ceva. */
    if (gazda) gazda.classList.toggle('ln-cos--gol', !doarRestul && !itemi.length);

    if (!itemi.length) {
      if (doarRestul) {
        lista.innerHTML = '';
        lista.hidden = true;
      } else {
        lista.innerHTML = '<p class="ln-cos__gol">Coșul e gol.</p>';
        if (prag) prag.hidden = true;
      }
      return;
    }
    lista.innerHTML = itemi.map(function (i) {
      var poza = i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : '';
      var linie = i.final_line_price !== undefined ? i.final_line_price : i.line_price;
      /* `key` identifică linia, nu produsul: două linii pot avea aceeași
         variantă cu proprietăți diferite, iar ștergerea trebuie să nimerească
         exact linia apăsată. */
      return '<div class="ln-cos__rand" data-cheie="' + i.key + '">' +
             (poza ? '<img src="' + poza + '" alt="" width="54" height="54" loading="lazy">' : '') +
             '<div class="ln-cos__rand-text">' +
             '<p class="ln-cos__rand-nume"></p>' +
             '<p class="ln-cos__rand-pret">' +
             (i.quantity > 1 ? '<span class="ln-cos__buc">' + i.quantity + ' × </span>' : '') +
             pretHTML(Math.round(linie / i.quantity), pretVechi(i.variant_id)) + '</p>' +
             '</div>' +
             '<button type="button" class="ln-cos__sterge" data-ln-cos-sterge ' +
             'aria-label="Scoate din coș">' +
             '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
             'stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
             '</button></div>';
    }).join('');
    /* numele îl punem ca text, nu ca HTML: un titlu cu ghilimele sau semne
       n-are voie să poată strica pagina */
    var randuri = lista.querySelectorAll('.ln-cos__rand-nume');
    itemi.forEach(function (i, n) {
      if (randuri[n]) randuri[n].textContent = i.product_title || i.title || '';
    });
  }

  /* Scoaterea unei linii din coș.

     Rândul dispare imediat, ca la adăugare — omul nu așteaptă serverul. Dacă
     cererea cade, citim coșul din nou și lista se întoarce la adevăr. */
  function stergeLinie(buton) {
    var rand = buton.closest('.ln-cos__rand');
    if (!rand || rand.dataset.sePleaca) return;
    var cheie = rand.getAttribute('data-cheie');
    if (!cheie) return;

    rand.dataset.sePleaca = '1';
    rand.style.opacity = '.45';
    rand.style.pointerEvents = 'none';

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: cheie, quantity: 0 })
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (c) {
          cosStiut = { total: c.total_price || 0, buc: c.item_count || 0 };
          arataLista(c);
          arataCosul(c);
        } else {
          return citesteCosul().then(function (x) { arataLista(x); arataCosul(x); });
        }
      })
      .catch(function () {
        citesteCosul().then(function (x) { arataLista(x); arataCosul(x); });
      });
  }

  function modConfirmare() {
    if (unul) unul.hidden = false;
    if (lista) { lista.hidden = true; lista.innerHTML = ''; }
    if (bifa) bifa.textContent = 'Adăugat în coș';

    /* Clasa asta se pune când fereastra s-a deschis din iconiță cu coșul gol,
       iar CSS-ul ascunde prin ea butonul de finalizare. Nimeni n-o scotea
       după aceea: odată ce vedeai coșul gol o dată, „Finalizează comanda"
       rămânea ascuns la fiecare adăugare ulterioară. Aici sigur nu e gol. */
    if (gazda) gazda.classList.remove('ln-cos--gol');
  }

  function deschideCosul() {
    if (!leaga()) return;
    arataEcran('confirm');
    deschide();
    if (cosStiut) arataCosul({ total_price: cosStiut.total, item_count: cosStiut.buc }, true);
    citesteCosul().then(function (c) { arataLista(c); arataCosul(c); });
  }

  /* ---------- adăugarea ---------- */
  function citesteCosul() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (c) {
          cosStiut = { total: c.total_price || 0, buc: c.item_count || 0 };
          var a = (c.attributes && c.attributes['Adaugat din']) || '';
          surseScrise = a ? a.split(', ') : [];
        }
        return c;
      });
  }

  /* Lista surselor ajunge pe comandă, în „Additional details". Proprietatea
     `_sursa` de pe fiecare linie spune exact de unde a venit fiecare produs;
     atributul de aici e rezumatul, ca să se vadă dintr-o privire. */
  function scrieSursaPeComanda(sursa) {
    /* Sursele le ținem minte local, ca să nu mai cerem coșul doar ca să
       aflăm ce scrie deja acolo. Scriem pe server o singură dată per sursă
       nouă, iar cererea nu blochează pe nimeni. */
    if (surseScrise && surseScrise.indexOf(sursa) >= 0) return;
    if (!surseScrise) surseScrise = [];
    surseScrise.push(sursa);
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { 'Adaugat din': surseScrise.join(', ') } })
    }).catch(function () {});
  }

  function pune(idVarianta, cate, sursa) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: idVarianta, quantity: cate || 1, properties: { _sursa: sursa } }]
      })
    }).then(function (r) { return r.ok ? r.json() : null; });
  }

  function catreMeta(id, numeProdus, pretProdus) {
    if (!window.lnMeta) return;
    window.lnMeta.adaugaInCos({ handle: id, nume: numeProdus, pret: pretProdus });
  }

  function varianta(buton) {
    if (buton.hasAttribute('data-variant')) return buton.getAttribute('data-variant');
    var f = buton.closest('form');
    var el = (f && f.querySelector('[name="id"]')) ||
             document.querySelector('[data-ln-variant-id]');
    return el ? el.value : null;
  }

  function cateBucati(buton) {
    var f = buton.closest('form');
    var el = (f && f.querySelector('[name="quantity"]')) ||
             document.querySelector('[data-ln-pdp] [name="quantity"]');
    var n = el ? parseInt(el.value, 10) : 1;
    return n > 0 ? n : 1;
  }

  /* Tot ce se poate afla fără server: numele, prețul și poza produsului pe
     care tocmai l-a apăsat omul. Le luăm din pagină, ca fereastra să fie
     plină din prima, nu după ce răspunde Shopify. */
  function dinPagina(buton) {
    var card = buton.closest('.ln-card');
    if (card) {
      var im = card.querySelector('img');
      return {
        nume: buton.getAttribute('data-nume') || '',
        pret: Math.round(parseFloat(buton.getAttribute('data-pret')) * 100) || 0,
        poza: im ? im.currentSrc || im.src : null
      };
    }
    var r = document.querySelector('[data-ln-pdp]');
    if (!r) return null;
    var g = document.querySelector('.ln-pdp .slide img');
    return {
      nume: r.getAttribute('data-ln-nume') || '',
      pret: Math.round(parseFloat(r.getAttribute('data-ln-pret')) * 100) || 0,
      poza: g ? g.currentSrc || g.src : null
    };
  }

  function adauga(buton, sursa) {
    var id = varianta(buton);
    if (!id) return false;

    var cate = cateBucati(buton);
    var local = dinPagina(buton);

    modConfirmare();
    arataEcran('confirm');
    deschide();

    /* pas 1: pictăm imediat, din ce știm deja */
    if (local) {
      arataProdus({ product_title: local.nume, price: local.pret, quantity: cate, image: local.poza });
      if (cosStiut) {
        arataCosul({
          total_price: cosStiut.total + local.pret * cate,
          item_count: cosStiut.buc + cate
        }, true);
      }
    }

    var radacina = document.querySelector('[data-ln-pdp]');

    /* pas 2: trimitem, apoi corectăm cu adevărul de pe server */
    pune(id, cate, sursa)
      .then(function (raspuns) {
        var cheieNoua = null;
        if (raspuns && raspuns.items && raspuns.items.length) {
          arataProdus(raspuns.items[0]);
          cheieNoua = raspuns.items[0].key || null;
        }

        if (buton.hasAttribute('data-variant')) {
          catreMeta(buton.getAttribute('data-variant'),
                    buton.getAttribute('data-nume'),
                    parseFloat(buton.getAttribute('data-pret')));
        } else if (radacina) {
          catreMeta(radacina.getAttribute('data-ln-varianta') ||
                    radacina.getAttribute('data-ln-handle'),
                    radacina.getAttribute('data-ln-nume'),
                    parseFloat(radacina.getAttribute('data-ln-pret')));
        }

        scrieSursaPeComanda(sursa);
        return citesteCosul().then(function (c) {
          arataCosul(c);
          if (c && cheieNoua) arataLista(c, cheieNoua);
        });
      })
      .catch(function () {
        inchide();
        var f = buton.closest('form');
        if (f) f.submit();
      });

    return true;
  }

  /* adăugarea din selector: fără altă fereastră peste */
  function adaugaDinSelector(buton) {
    if (buton.disabled) return;
    var id = buton.getAttribute('data-varianta');
    if (!id) return;

    var textVechi = buton.textContent;
    buton.disabled = true;
    buton.textContent = 'Se adaugă…';

    var pretBani = Math.round(parseFloat(buton.getAttribute('data-pret')) * 100) || 0;
    if (cosStiut) {
      arataCosul({ total_price: cosStiut.total + pretBani, item_count: cosStiut.buc + 1 }, true);
    }

    pune(id, 1, 'fereastra')
      .then(function () {
        catreMeta(id, buton.getAttribute('data-nume'), parseFloat(buton.getAttribute('data-pret')));
        scrieSursaPeComanda('fereastra');
        return citesteCosul().then(function (c) { arataCosul(c); });
      })
      .then(function () {
        buton.textContent = 'Adăugat ✓';
        buton.classList.add('e-adaugat');
        setTimeout(function () {
          buton.textContent = textVechi;
          buton.classList.remove('e-adaugat');
          buton.disabled = false;
        }, 1600);
      })
      .catch(function () {
        buton.textContent = textVechi;
        buton.disabled = false;
      });
  }

  /* ---------- coșul se schimbă și în formularul EasySell ----------

     În formular omul poate șterge produse. Ștergerea o face aplicația lor,
     direct pe coșul Shopify — tema nu află nimic. Așa că după ce închide
     formularul cu „×" rămânea cu bulina veche în header (7 produse) și cu un
     sertar care spunea altceva. Măsurat de proprietar: bulina zicea 7, coșul
     era gol.

     Nu putem prinde un eveniment de la ei, nu emit niciunul. Ne uităm la
     fereastra lor: cât timp e deschisă verificăm din 600 în 600 ms, iar în
     clipa în care se închide cerem temei bucățile proaspete. Ceasul pornește
     doar când chiar apare formularul în pagină, deci pe restul site-ului nu
     rulează nimic. */
  function formularDeschis() {
    var m = document.querySelector('.es-modal, #easysell-modal');
    if (!m) return false;
    var r = m.getBoundingClientRect();
    return r.height > 40 && getComputedStyle(m).display !== 'none';
  }

  function urmaresteFormularul() {
    var ceas = null;
    var eraDeschis = false;

    function verifica() {
      var acum = formularDeschis();
      if (eraDeschis && !acum) {
        improspateazaTema();
        clearInterval(ceas);
        ceas = null;
      }
      eraDeschis = acum;
      if (!acum && ceas) { clearInterval(ceas); ceas = null; }
    }

    function porneste() {
      if (ceas || !formularDeschis()) return;
      eraDeschis = true;
      ceas = setInterval(verifica, 600);
    }

    if (typeof MutationObserver === 'function') {
      new MutationObserver(porneste).observe(document.body, {
        childList: true, subtree: true, attributes: true,
        attributeFilter: ['style', 'class']
      });
    }
    porneste();
  }

  function porneste() {
    urmaresteFormularul();
    /* Citim coșul o singură dată, în liniște, ca prima apăsare să aibă deja
       de unde estima totalul. Fără asta, primul „Adaugă în coș" era singurul
       care aștepta serverul. */
    citesteCosul().catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', porneste);
  } else {
    porneste();
  }

  /* Cârlig pentru assets/la-nani-easysell.js: „Finalizează comanda" nu se
     poate prinde în fereastră, pentru că ascultătorul lor stă pe document,
     pe captură, și oprește evenimentul înainte să coboare până la noi. */
  window.lnCos = {
    inchide: function () { inchide(); },
    improspateaza: improspateazaTema
  };

  /* ---------- interceptarea butoanelor ---------- */
  document.addEventListener('click', function (ev) {
    if (!ev.target.closest) return;
    if (!document.querySelector('[data-ln-cos]')) return;
    if (ev.target.closest('[data-ln-cos]')) return;   /* clickurile din fereastră au ascultătorul lor */

    /* Iconița de coș din header deschide fereastra noastră, nu sertarul
       temei. Sertarul rămâne în pagină, dar nu-l mai vede nimeni. */
    if (ev.target.closest('#cart-icon-bubble')) {
      ev.preventDefault();
      ev.stopPropagation();
      deschideCosul();
      return;
    }

    var pagina = ev.target.closest('[data-ln-checkout]');
    var card = ev.target.closest('[data-ln-add]');
    var buton = pagina || card;
    if (!buton || buton.disabled) return;
    if (buton.closest('#easysell-modal')) return;     /* butoanele din formular rămân ale lor */

    ev.preventDefault();
    ev.stopPropagation();
    if (!adauga(buton, pagina ? 'pagina-produs' : 'colectie')) {
      var f = buton.closest('form');
      if (f) f.submit();
    }
  }, true);
})();
